import { atom, useAtom } from "jotai";

import { type FundingRates } from "#/types/funding";

export const fundingRatesAtom = atom<FundingRates>({});

export const useFundingRates = () => {
  const [fundingRates, setFundingRates] = useAtom(fundingRatesAtom);

  return {
    fundingRates,
    setFundingRates,
  };
};
